const monitoring = () => {
    const block = document.getElementById('monitoring');

    if (!block) {
        return;
    }

    /* Переменные для хранения списка программ для разных операторов */
    async function getPrograms() {
        const DPO_TGU = 'https://2025.api.tgu-dpo.ru/regions/GetAllProgramsWithRegions?isShowTgu=true&&isVisibleWithoutDirection=true',
            PO_TGU = 'https://2025.api.tgu-dpo.ru/regions/GetAllProgramsWithRegions?isShowTgu=true&&isVisibleWithoutDirection=true&&withoutEducation=true',
            OFLINE = 'https://2025.api.tgu-dpo.ru/regions/GetAllProgramsWithRegions?isShowTgu=true&isVisibleWithoutDirection=true&withoutEducation=true&exceptOffline=false&exceptOnline=true';
        
        const loader = document.querySelector('.monitoring__loader');

        try {
            let result_TGU_DPO_FETCH = await getJson(DPO_TGU),
                result_TGU_PO_FETCH = await getJson(PO_TGU),
                result_ofline = await getJson(OFLINE),
                arrTgu = [
                    ...result_TGU_DPO_FETCH,
                    ...result_TGU_PO_FETCH
                ],
                arrOffline = [
                    ...result_ofline
                ];
            
            /* Добавление тега ПО */
            [...result_TGU_PO_FETCH, ...arrOffline].map(
                (item) => {
                item.po = true;
                }
            );

            /* Добавление оператора для программ */
            arrTgu.map((it) => (it.operator = 'TGU'));
            arrOffline.map((it) => (it.operator = 'TGU'));
            
            loader.classList.remove('active');
            dataOutput(arrTgu, arrOffline);
        } catch(e) {
            loader.classList.remove('active');
            block.innerHTML = `
                <p style="font-size: 20px; color: #E30016; text-align: center; font-weight: 700">Не удалось подключиться к серверу. Попробуйте зайти позже.</p>
            `
            console.log(e);

        }
    };

    /* Вывод данных */
    function dataOutput(TGU, OFFLINE) {
        let wrap = document.createElement('div');
        wrap.classList.add('monitoring__wrap');
        wrap.append(createList(TGU, 'TGU'));
        wrap.append(createList(OFFLINE, 'OFFLINE'));
        block.append(wrap); 
    }

    /* Создание таблицы с данными */
    function createList(data, operator) {
        const block = document.createElement('div'),
            tbody = document.createElement('tbody'),
            modals = document.createElement('div');
        
        block.classList.add('monitoring__block');

        if (data.length < 1) {
            block.innerHTML = `
                <h3>Программы ${operator}</h3>
                <p style="font-size: 20px; color: #E30016; text-align: center; font-weight: 700">Нет доступных программ!</p>
            `
        } else {
            data.forEach(function (elem, i) {
                const {name, id, shortName, directionName, directionId, regions, po} = elem;

                tbody.innerHTML += `
                    <tr>
                        <td>${i + 1}</td>
                        <td><button type="button" data-modal-id="${shortName + '-' + id}" data-modal-open>${name}</button></td>
                        <td>${id}</td>
                        <td>${po == true ? "ПО" : "ДПО"}</td>
                        <td>${shortName}</td>
                        <td>${directionName} (id - ${directionId})</td>
                    </tr>
                `
                /* Создание модального окна со списком регионов */
                const modal = document.createElement('div');
                modal.classList.add('monitoring__modal', 'custom-modal__hidden');
                modal.setAttribute('id', `${shortName + '-' + id}`); 

                let arrRegions = [];

                if (operator != "OFFLINE") {
                    for (let j = 0; j < regions.length; j++) {
                        arrRegions.push(regions[j].regionName);
                    }      

                    arrRegions.sort();
    
                    for (let j = 0; j < arrRegions.length; j++) {
                        modal.innerHTML += `
                            <p>${j + 1}: ${arrRegions[j]}</p>
                        `
                    }      
                } else {
                    for (let j = 0; j < regions.length; j++) {
                        arrRegions.push({
                            "name": regions[j].regionName,
                            "cities": regions[j].cities
                        });
                    }      
    
                    for (let j = 0; j < arrRegions.length; j++) {
                        if (arrRegions[j].cities.length < 1) {
                            modal.innerHTML += `
                                <div style="margin-bottom: 10px">
                                    <p>${j + 1}: ${arrRegions[j].name}</p>
                                    <p style="color: #703EFF;">&nbsp;&nbsp; —</p>
                                </div>
                            `
                        } else {
                            let cities = '';

                            arrRegions[j].cities.forEach(city => {
                                cities += `<p style="color: #703EFF;">&nbsp;&nbsp; ${city.city}</p>`;  
                                                              
                            })

                            modal.innerHTML += `
                                <div style="margin-bottom: 10px">
                                    <p>${j + 1}: ${arrRegions[j].name}</p>
                                    ${cities}
                                </div>
                            `                            
                        }
                    }  
                }                    
                
                modals.append(modal);
            });
    
            block.innerHTML = `
                <h3>Программы ${operator} (${data.length})</h3>
                <table>
                    <thead>
                        <tr>
                            <td>№</td>
                            <td>Название</td>
                            <td>OdinId</td>
                            <td>Level</td>
                            <td>Url</td>
                            <td>Направление</td>
                        </tr>
                    </thead>
                    ${tbody.innerHTML}
                </table>
                ${modals.innerHTML}
            `
        }

        return block;
    }

    /* Запрос на получение json */
    async function getJson(patch) {
        let response = await fetch(patch),
            result = await response.json();

        /*Добавление свойства regions в объект, если оно отсутствует */
        result.map((item) => {
            if (!item.regions) {
                item.regions = regionsDefault;
            }
        });

        return result;
    }

    getPrograms();
}

export default monitoring;